module.exports = __webpack_public_path__ + "static/media/Allfresfo-Jueves de frescura.d466a167.jpg";